package app.smartcoding.realrate.presentation.components

import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.AccountCircle
import androidx.compose.material.icons.filled.Person
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import app.smartcoding.realrate.domain.model.AuthUser
import coil3.compose.SubcomposeAsyncImage

@Composable
fun UserAvatar(user: AuthUser) {
    val googleColors =
        listOf(Color(0xFF4285F4), Color(0xFF34A853), Color(0xFFFBBC05), Color(0xFFEA4335))

    val borderModifier = when (user) {
        is AuthUser.User -> {
            Modifier.border(
                width = 3.dp,
                brush = Brush.sweepGradient(googleColors),
                shape = CircleShape
            )
        }

        AuthUser.Unknown -> {
            Modifier.border(
                width = 3.dp,
                color = MaterialTheme.colorScheme.onSurfaceVariant,
                shape = CircleShape
            )
        }
    }

    Box(
        modifier = Modifier
            .size(88.dp)
            .then(borderModifier)
            .padding(6.dp)
            .clip(CircleShape),
        contentAlignment = Alignment.Center
    ) {
        when (user) {
            AuthUser.Unknown -> {
                Icon(
                    Icons.Default.Person,
                    contentDescription = "Anonymous Avatar",
                    modifier = Modifier.size(60.dp),
                    tint = MaterialTheme.colorScheme.onSurfaceVariant
                )
            }

            is AuthUser.User -> {
                SubcomposeAsyncImage(
                    model = user.photoUrl,
                    contentDescription = "Profile picture",
                    modifier = Modifier
                        .matchParentSize()
                        .clip(CircleShape),

                    loading = {
                        Icon(
                            imageVector = Icons.Default.AccountCircle,
                            contentDescription = null,
                        )
                    },

                    error = {
                        Icon(
                            imageVector = Icons.Default.AccountCircle,
                            contentDescription = "Error loading image",
                        )
                    }
                )

//                Icon(
//                    Icons.Default.Person,
//                    contentDescription = "User Avatar",
//                    modifier = Modifier.size(60.dp),
//                    tint = MaterialTheme.colorScheme.onSurface
//                )
            }
        }
    }
}